import React from 'react'
import styled from 'styled-components'
import { Button } from '@streamr/streamr-layout'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'
import MONETISATION from '~shared/Icon/assets/monetisation.png'
import Container from '~shared/Container'
import H from '~shared/Hero'
import FeatureList from '~shared/FeatureList'
import ButtonWrapper from '~shared/ButtonWrapper'
import { EMPOWER, MONETISE, DECENTRALIZATION } from '~shared/FeatureGlyph'
import Link from '~shared/Link'
import urls from '~utils/urls'

const StyledParagraph = styled(H.Paragraph)`
    @media (min-width: ${TABLET}px) {
        margin-bottom: 40px;
        margin-right: 130px;
    }

    @media (min-width: ${DESKTOP}px) {
        margin-bottom: 0;
        margin-right: 0;
        max-width: none;
    }
`

const StyledIcon = styled(H.Icon)`
    && {
        margin: 0;
    
        @media (min-width: ${TABLET}px) {
            min-width: 260px;
        }
    }
`

const StyledHeadline = styled(H.Headline)`
    && {
        margin: 0;
        text-align: left;
        width: 100%;
    }
`

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 2rem auto 3rem;

    ${StyledHeadline} {
        margin-top: 4rem;
    }

    @media (min-width: ${TABLET}px) {
        margin: 5rem auto 2rem;

        ${StyledHeadline} {
            margin-top: 2.5rem;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        flex-direction: row;
        margin: 6rem auto 6.5rem;

        ${StyledHeadline} {
            margin-top: 1.5rem;
            margin-left: 18rem;
            white-space: nowrap;
        }
    }
`

const StyledFeatureList = styled(FeatureList)`
    display: none;

    @media (min-width: ${TABLET}px) {
        display: block;
    }

    @media (min-width: ${DESKTOP}px) {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }
`

const Actions = styled.div`
    margin-top: 3rem;

    ${ButtonWrapper} {
        width: 100%;
    }

    ${Button} {
        width: 100%;
        padding: 0;
    }

    ${ButtonWrapper} + ${ButtonWrapper} {
        margin-top: 1.5rem;
    }

    @media (min-width: ${TABLET}px) {
        margin-top: 4.5rem;

        ${ButtonWrapper} {
            width: 168px;
        }

        ${ButtonWrapper} + ${ButtonWrapper} {
            margin-top: 0;
            margin-left: 1.5rem;
        }
    }
`

const ContentGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;

    @media (min-width: ${DESKTOP}px) {
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 7.5rem;

        ${StyledParagraph} {
            grid-row: 1;
            grid-column: 1;
        }

        ${Actions} {
            grid-row: 2;
            grid-column: 1;
            align-self: end;
        }

        ${StyledFeatureList} {
            grid-row: 1 / 3;
            grid-column: 2;
        }
    }
`

const Hero = (props) => (
    <Container>
        <H {...props}>
            <TitleContainer>
                <StyledIcon src={MONETISATION} $appear />
                <StyledHeadline $appear>
                    Data Unions &mdash;
                    <br />
                    The ethical new way
                    <br />
                    to sell user data
                </StyledHeadline>
            </TitleContainer>
            <ContentGrid>
                <StyledParagraph $appear>
                    Integrate your app with the Data Unions framework, or build one from scratch.
                    Gain meaningful consent from your users and reward them by sharing data sales revenue.
                </StyledParagraph>
                <StyledFeatureList>
                    <FeatureList.Item title="Monetise" glyph={MONETISE} $appear>
                        Create valuable datasets with full user permission
                    </FeatureList.Item>
                    <FeatureList.Item title="Empower" glyph={EMPOWER} $appear>
                        Reward your users by sharing data revenue
                    </FeatureList.Item>
                    <FeatureList.Item title="Crowdsource" glyph={DECENTRALIZATION} $appear>
                        Incentivise creation of hard-to-get data
                    </FeatureList.Item>
                </StyledFeatureList>
                <Actions>
                    <ButtonWrapper>
                        <Button
                            tag="a"
                            href={urls.docs.dataUnions}
                            kind="primary"
                            size="big"
                        >
                            Data Union Docs
                        </Button>
                    </ButtonWrapper>
                    <ButtonWrapper>
                        <Button
                            tag={Link}
                            href={urls.developers.dataFund}
                            kind="primary"
                            size="big"
                            outline
                            noDecoration
                            noHover
                        >
                            Apply for funding
                        </Button>
                    </ButtonWrapper>
                </Actions>
            </ContentGrid>
        </H>
    </Container>
)

export default styled(Hero)`
    margin: 0 auto;
    color: #0C009A;

    @media (min-width: ${TABLET}px) {
        width: 560px;
    }

    @media (min-width: ${DESKTOP}px) {
        width: 980px;
    }
`
